/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect, useContext } from "react";
import produce from "immer";
import { LocationsContext } from ".";
import fetchHelper from "../../services/fetchHelper";

const ReminderSettings = ({ value, onChange, title, dataKey }) => {
  const [editForm, setEditForm] = useState(false);
  return (
    <div className="row rowStretch first-reminder">
      <div className="col col-s-50 col50">
        <label className="inCal">
          <span>{title}</span>
          <input type="text" value={value} onChange={onChange} data-key={dataKey} disabled={!editForm} />
        </label>
      </div>
      <div className="col col-s-50 col50 col-patient-reminder-settings">
        <label className="inBtn">
          <span>&nbsp;</span>
          <ul>
            {editForm ? (
              <>
                <li>
                  <button className="btn btnSuccess" onClick={() => setEditForm(false)}>
                    Save
                  </button>
                </li>
                <li>
                  <button className="btn btnNoTxt" onClick={() => setEditForm(false)}>
                    <i className="icon-64 close-flat-ico" style={{ width: 20, height: 20 }}></i>
                  </button>
                </li>
              </>
            ) : (
              <li>
                <button className="btn btnTealL" onClick={() => setEditForm(true)}>
                  Edit
                </button>
              </li>
            )}
          </ul>
        </label>
      </div>
    </div>
  );
};

const PatientEngagement = () => {
  const { location, setLocation } = useContext(LocationsContext);
  const [data, setData] = useState(location || {});

  useEffect(() => {
    console.log(location.cancel);
    if (location.cancel) {
      setData(location);
    }
  }, [location.cancel]);

  const save = async () => {
    if (location.loading) return false;
    try {
      setLocation({ loading: true });
      const response = await fetchHelper.put("/patientmanagement/rest/location/" + data.id, data);
      console.log(response);
      setLocation({ loading: false, openForm: false });
      setLocation(response);
    } catch (err) {
      setLocation({ loading: false });
      console.log(err);
    }
  };

  useEffect(() => {
    console.log(location.save);
    if (location.save) {
      save();
    }
  }, [location.save]);

  const onChange = (e) => {
    const element = e.target;
    const key = element.dataset.key;
    const checked = element.checked;
    let value = element.value;
    setData((prev) =>
      produce(prev, (draft) => {
        if (key === "enableFollowUp") {
          value = checked;
        }
        draft[key] = value;
      })
    );
  };

  return (
    <div className="tabContent ptInformation">
      <div className="content">
        <div className="row rowStretch">
          <div className="col col100">
            <div className="grpHdrPg">
              <h3>
                <span>Location Profile:</span>
              </h3>
            </div>
          </div>
          <div className="col col50">
            <div className="row rowStretch">
              <div className="col col-l-100 col100">
                <label>
                  <span>Voice Message</span>
                  <textarea
                    placeholder="Enter text"
                    className="fullWidth fixed-size"
                    value={data?.voiceMessage}
                    onChange={onChange}
                    data-key="voiceMessage"
                  />
                </label>
              </div>
            </div>
            <div className="row rowStretch">
              <div className="col col100">
                <label>
                  <span>SMS Text</span>
                  <textarea
                    placeholder="Enter text"
                    className="fullWidth fixed-size"
                    value={data?.smsTextMessage}
                    onChange={onChange}
                    data-key="smsTextMessage"
                  />
                </label>
              </div>
            </div>
            <div className="row rowStretch">
              <div className="col col100">
                <label>
                  <span>Email</span>
                  <textarea
                    placeholder="Enter text"
                    className="fullWidth fixed-size"
                    value={data?.emailMessage}
                    onChange={onChange}
                    data-key="emailMessage"
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="col col-l-100 col50 patient-reminder-settings" style={{ paddingLeft: "20px" }}>
            <div className="grpHdr">
              <h3>Patient Reminder Settings</h3>
            </div>
            <ReminderSettings
              title="First Reminder (Days)"
              value={data?.reminderSettingFirst}
              onChange={onChange}
              dataKey="reminderSettingFirst"
            />
            <ReminderSettings
              title="Second Reminder (Days)"
              value={data?.reminderSettingSecond}
              onChange={onChange}
              dataKey="reminderSettingSecond"
            />
            <div className="row rowStretch">
              <div className="col col-s-100 col50">
                <label className="inCal">
                  <span>Notification Settings</span>
                  <select
                    value={data?.reminderSettingNotification}
                    onChange={onChange}
                    data-key="reminderSettingNotification"
                  >
                    <option value="">Select</option>
                    {["10am-12pm", "12pm-2pm"].map((item) => (
                      <option key={item} value={item}>
                        {item} PST
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50"></div>
            </div>

            <div className="row rowStretch">
              <div className="col col100">
                <label className="chk-option" style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    className="chk"
                    value={data?.enableFollowUp}
                    checked={data?.enableFollowUp}
                    onChange={onChange}
                    data-key="enableFollowUp"
                  />
                  <span className="chkmrk" style={{ width: "10px" }}></span>
                  <span className="lblTxt" style={{ display: "inline" }}>
                    Enable patient follow-up upon received transmission
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!location.openForm ? (
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(255,255,255,0.25)",
          }}
        />
      ) : null}
    </div>
  );
};

export default PatientEngagement;
